import {
  SpeechRecognitionGlobalSettingsComponent,
  SpeechRecognitionConfigComponent,
  SpeechRecognitionEngineConfigDirective
} from './speech-recognition-config';

import {
    SpeechRecognitionResultsComponent,
} from './speech-recognition-results';

import {
    SpeechRecognitionStatsComponent,
} from './speech-recognition-stats';

export const scSpeechRecognitionModule = 'sc-speech-recognition';

angular
  .module(scSpeechRecognitionModule, [])
  .component('srGlobalSettings', SpeechRecognitionGlobalSettingsComponent)
  .component('scSpeechRecognitionConfig', SpeechRecognitionConfigComponent)
  .component('scSpeechRecognitionResults', SpeechRecognitionResultsComponent)
  .component('scSpeechRecognitionStats', SpeechRecognitionStatsComponent)
  .directive('srEngineConfig', SpeechRecognitionEngineConfigDirective);



// WEBPACK FOOTER //
// ./src/speech/speech-recognition.module.js